import * as React from "react";
import { Label, Icon } from "semantic-ui-react";
import { TestConfig } from "../views/TestingView";

export enum TestStatusEnum {
  NotAvailable,
  NotTested,
  Queuing,
  Testing,
  Error,
  Done,
}

export interface BaseStatus {
  status: TestStatusEnum;
}

type NotAvailableStatus = BaseStatus & {
  status: TestStatusEnum.NotAvailable;
};

type NotTestedStatus = BaseStatus & {
  status: TestStatusEnum.NotTested;
};

type QueuingStatus = BaseStatus & {
  status: TestStatusEnum.Queuing;
};

type TestingStatus = BaseStatus & {
  status: TestStatusEnum.Testing;
  progress: number;
};

type ErrorStatue = BaseStatus & {
  status: TestStatusEnum.Error;
  message: string;
};

type DoneStatus = BaseStatus & {
  status: TestStatusEnum.Done;
  performance: number;
  output: string;
};

export type TestStatus =
  | NotAvailableStatus
  | NotTestedStatus
  | QueuingStatus
  | TestingStatus
  | ErrorStatue
  | DoneStatus;

export default function TestingStatus(props: {
  result: TestStatus;
  testConfig?: TestConfig;
}) {
  function getColor() {
    switch (props.result.status) {
      case TestStatusEnum.Done:
        return "green";
      case TestStatusEnum.Testing:
        return "yellow";
      case TestStatusEnum.Error:
        return "red";
    }
  }

  function getText() {
    switch (props.result.status) {
      case TestStatusEnum.NotTested:
        return "Not Tested";
      case TestStatusEnum.NotAvailable:
        return "Not Available";
      case TestStatusEnum.Done:
        return `Done - avg ${parseFloat(
          props.result.performance.toPrecision(3),
        )}ms per exec`;
      case TestStatusEnum.Queuing:
        return "In Queue";
      case TestStatusEnum.Testing:
        return `Testing - ${props.result.progress}/${
          props.testConfig ? props.testConfig.retryTimes : "??"
        }`;
      case TestStatusEnum.Error:
        return `Error - ${props.result.message}`;
    }
  }

  function getIcon() {
    switch (props.result.status) {
      case TestStatusEnum.NotTested:
        return <Icon name="bullseye" />;
      case TestStatusEnum.Testing:
        return <Icon name="spinner" loading />;
      case TestStatusEnum.Queuing:
        return <Icon name="spinner" />;
      case TestStatusEnum.Error:
      case TestStatusEnum.NotAvailable:
        return <Icon name="times" />;
      case TestStatusEnum.Done:
        return <Icon name="check" />;
      default:
        return null;
    }
  }

  return (
    <Label color={getColor()} size="large">
      {getIcon()}
      {getText()}
    </Label>
  );
}
